import { useCallback, useEffect, useRef, useState } from "react";
import { listMyRulebooks } from "../rulebookAttachmentClient";
/**
 * The signed-in user's own Rulebooks for a picker, loaded when enabled and on `reload` (the picker reloads on open).
 * A failed refresh keeps the last good list, so the form still shows what's attached, and raises `hasError`, which
 * the picker shows as Retry instead of offering possibly stale cards. Only the latest request may write, so a slow
 * earlier load can't overwrite a newer one.
 */
export default function useMyRulebooks({ isEnabled }) {
    const [stateRulebooks, setStateRulebooks] = useState(null);
    const [stateIsLoading, setStateIsLoading] = useState(false);
    const [stateIsError, setStateIsError] = useState(false);
    const refLatestRequest = useRef(0);
    const reload = useCallback(async () => {
        refLatestRequest.current += 1;
        const request = refLatestRequest.current;
        setStateIsLoading(true);
        setStateIsError(false);
        try {
            const rulebooks = await listMyRulebooks();
            if (request === refLatestRequest.current) {
                setStateRulebooks(rulebooks);
            }
        }
        catch {
            if (request === refLatestRequest.current) {
                setStateIsError(true);
            }
        }
        finally {
            if (request === refLatestRequest.current) {
                setStateIsLoading(false);
            }
        }
    }, []);
    useEffect(() => {
        if (isEnabled) {
            void reload();
        }
    }, [isEnabled, reload]);
    return { rulebooks: stateRulebooks, isLoading: stateIsLoading, hasError: stateIsError, reload };
}
